/* import __COLOCATED_TEMPLATE__ from './hand-over-closing-messages-editor.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type BotPart from 'embercom/models/operator/bot-intro/part';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    messages: BotPart[];
    addPart: () => void;
    removePart: (part: BotPart) => void;
    reorderParts: (parts: BotPart[]) => void;
  };
}

const HandOverClosingMessagesEditor = templateOnlyComponent<Signature>();
export default HandOverClosingMessagesEditor;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::HandOverClosingMessagesEditor': typeof HandOverClosingMessagesEditor;
  }
}
